import React from 'react';

// Use public folder paths for reliable image loading
const logoVariants = {
  header: {
    png: {
      small: '/images/logo/twisted-cloud-logo-small.png',
      medium: '/images/logo/twisted-cloud-logo-medium.png',
      large: '/images/logo/twisted-cloud-logo.png'
    },
    sizes: '(max-width: 400px) 207px, (max-width: 800px) 310px, 414px',
    dimensions: { width: 414, height: 188 }
  },
  
  compact: {
    png: {
      small: '/images/logo/twisted-cloud-logo-small.png',
      medium: '/images/logo/twisted-cloud-logo-medium.png',
      large: '/images/logo/twisted-cloud-logo.png'
    },
    sizes: '(max-width: 400px) 120px, (max-width: 800px) 180px, 240px',
    dimensions: { width: 240, height: 109 }
  },
  
  footer: {
    png: {
      standard: '/images/logo/twisted-cloud-logo-footer.png'
    },
    sizes: '155px',
    dimensions: { width: 155, height: 71 }
  }
};

/**
 * OptimizedLogo Component
 * 
 * A performance-optimized logo component that uses public folder images for reliable loading
 */
const OptimizedLogo = ({
  variant = 'header',
  alt = 'Twisted Cloud Solutions',
  className = '',
  loading = 'lazy',
  priority = false,
  onClick,
  style = {},
  ...props
}) => {
  const config = logoVariants[variant] || logoVariants.header;
  
  // Build srcSet for PNG
  const buildSrcSet = (sources) => {
    if (variant === 'footer') {
      return sources.standard;
    }
    return `${sources.small} 400w, ${sources.medium} 800w, ${sources.large} 1200w`;
  };
  
  const pngSrcSet = buildSrcSet(config.png);
  
  // Default src (fallback)
  const defaultSrc = variant === 'footer' ? config.png.standard : config.png.large;
  
  // Loading strategy
  const loadingStrategy = priority ? 'eager' : loading;
  
  return (
    <img
      src={defaultSrc}
      srcSet={pngSrcSet}
      sizes={config.sizes}
      alt={alt}
      width={config.dimensions.width}
      height={config.dimensions.height}
      loading={loadingStrategy}
      decoding={priority ? 'sync' : 'async'}
      onClick={onClick}
      className={`optimized-logo ${className}`}
      style={{
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
        ...style
      }}
      {...props}
    />
  );
};

// Convenience components for specific use cases
export const HeaderLogo = (props) => (
  <OptimizedLogo variant="header" priority={true} loading="eager" {...props} />
);

export const CompactLogo = (props) => (
  <OptimizedLogo variant="compact" {...props} />
);

export const FooterLogo = (props) => (
  <OptimizedLogo variant="footer" {...props} />
);

export default OptimizedLogo;
